import { updateOrderState } from '../api/updateOrderState';
import { updatePaymentState } from '../api/updatePaymentState';
import { Order } from '../../../../app/models/business/Order';

interface HandleStateChangeParams {
  dataOrder: Order;
  statusOrderTo?: string;
  statusPaymentTo?: string;
  setLoading: (value: boolean) => void;
  setStatusModalData: (value: any) => void;
  notistick: (msg: string, opts: any) => void;
  onChangeOrder: (order: Order) => void;
  customFormDialog: { handleCancel: () => void };
  reLoad: () => void;
  extraData?: {
    comments?: string;
    attachments?: any[];
    link_payments?: string[];
    payment_gateway_id?: string | null;
  };
}

export const handleOrderAndPaymentStateChange = async ({
  dataOrder,
  statusOrderTo,
  statusPaymentTo,
  setLoading,
  setStatusModalData,
  notistick,
  onChangeOrder,
  customFormDialog,
  reLoad,
  extraData
}: HandleStateChangeParams) => {
  setLoading(true);

  const updates: Partial<Order> = {};

  try {
    if (
      statusOrderTo &&
      dataOrder.order_state.order_state_id !== statusOrderTo &&
      !statusPaymentTo
    ) {
      const result = await updateOrderState({
        order_id: dataOrder.order_id,
        order_state_id: statusOrderTo,
        comments: extraData?.comments,
      });

      updates.order_state = {
        name: result.order_state_name,
        order_state_id: result.order_state_id,
      };
    }

    if (statusPaymentTo && dataOrder.payment.payment_state.payment_state_id !== statusPaymentTo) {
      const result = await updatePaymentState({
        order_id: dataOrder.order_id,
        payment_state_id: statusPaymentTo,
        operation_order_id: dataOrder.operation?.operation_order_id ?? '',
        marketplace_id: dataOrder.marketplace.marketplace_id,
        ...extraData,
      });

      updates.payment = {
        ...dataOrder.payment,
        payment_state: {
          name: result.payment_state_name ?? statusPaymentTo,
          payment_state_id: statusPaymentTo,
        },
      };
    }

    if (Object.keys(updates).length > 0) {
      onChangeOrder({ ...dataOrder, ...updates });
      notistick('Estados actualizados correctamente', { variant: 'success' });
    } else {
      notistick('No hay cambios en los estados.', { variant: 'info' });
    }
  } catch (err: any) {
    notistick(err.response?.data || 'Error al actualizar estados', {
      variant: 'error',
    });
  } finally {
    setLoading(false);
    setStatusModalData(null);
    customFormDialog.handleCancel();
    reLoad();
  }
};
